import { Box } from "@material-ui/core";
import React from "react";

export const ContentWrapper = ({ ...props }: any) => {
  return (
    <Box
      padding="50px 20px"
      bgcolor="#F2F5F7"
      display="flex"
      justifyContent="center"
      minHeight="100vh"
      {...props}
    />
  );
};
